type TextLikeNode = {
  _text?: string
  value?: string
}

const SINGLE_LINE_TEXT_HEIGHT_PX = 40

function readNodeText(value: unknown): string | undefined {
  if (typeof value === 'string') return value

  if (value && typeof value === 'object') {
    const node = value as TextLikeNode

    if (typeof node._text === 'string') return node._text
    if (typeof node.value === 'string') return node.value
  }

  return undefined
}

function shouldUseTextareaForText(source: any): boolean {
  const grabVertical = readNodeText(source?.grabVertical)?.trim().toLowerCase()
  if (grabVertical === 'true') {
    return true
  }

  const rawHeight = readNodeText(source?.height)?.trim()
  if (!rawHeight) {
    return false
  }

  if (rawHeight.endsWith('r')) {
    const rows = Number.parseInt(rawHeight.slice(0, -1), 10)
    return Number.isFinite(rows) && rows > 1
  }

  const heightPx = Number.parseInt(rawHeight.replace(/px$/i, ''), 10)
  return Number.isFinite(heightPx) && heightPx > SINGLE_LINE_TEXT_HEIGHT_PX
}

export function normalizeFormElementType(source: any): string | undefined {
  const rawType = readNodeText(source?.type) ?? readNodeText(source?.elementType)
  const normalizedType = rawType?.toUpperCase()

  if (!normalizedType) return undefined

  if (normalizedType === 'MULTILINETEXT') {
    return 'TEXTAREA'
  }

  if (normalizedType === 'TEXT' && shouldUseTextareaForText(source)) {
    return 'TEXTAREA'
  }

  return normalizedType
}

/** XML height=Nr / px belongs on the editor (rows), not the labeled cell. */
export function shouldSkipXmlHeightOnElementContainer(normalizedType: string | undefined): boolean {
  const type = String(normalizedType ?? '').toUpperCase()
  return type === 'TEXTAREA' || type === 'MULTILINETEXT'
}

export function shouldHoistElementFieldLabel(options: {
  isLabelType: boolean
  hasSideActions: boolean
  labelText: string
}): boolean {
  if (options.isLabelType) return false
  if (!options.hasSideActions) return false
  return options.labelText.trim() !== ''
}
